module.exports = __webpack_public_path__ + "static/media/2_15.a50e42c0.png";